import React from "react";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { NoDataAvailableDiv } from "../../components/NoDataAvailableDiv";
import Panel from "../../components/panels/panel";
import { Button, Icon } from "semantic-ui-react";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "utilities";

interface Props {
  userActions: server.dto.UserAction[]
  userActionsUrl?: string
  displayRemoteAddress: boolean
  title: string
}

const UserActionRowCard = ({ item, displayRemoteAddress, url }: {
  item: server.dto.UserAction
  displayRemoteAddress: boolean
  url?: string
}) => {
  const cssClass = (url)
    ? "hoverable"
    : null;

  const gotoUrl = () => {
    if (url) {
      document.location.href = url;
    }
  };

  const createdMoment = moment.utc(item.createdUtc);

  return <tr className={cssClass} onClick={gotoUrl}>
    <td>
      <UserAvatar user={item.user} size="avatar" />
    </td>
    <td title={formatWrittenDateTimeUtc(createdMoment)}>
      <div className="s1_small">{item.message}</div>
      <div className="s1_smaller s1_gray">{createdMoment.fromNow()}</div>
    </td>
    {displayRemoteAddress && <td style={{ textAlign: "right" }} className="s1_small">
      {item.remoteAddress}
    </td>}
  </tr>;
};

const UserActionPanel = (props: Props) => {
  return <Panel
    title={props.title}
    panelClassName="s1_related-feature-panel">
    <UserActionContent {...props} />
  </Panel>;
};

const UserActionContent = (props: Props) => {
  if (props.userActions.length === 0) {
    return (<NoDataAvailableDiv />);
  }

  const navigateToUserActions = () => {
    document.location.href = props.userActionsUrl;
    return false;
  };

  return <>
    <div className="margin-bottom-larger">
      <table className="s1_table list">
        <tbody>
          {props.userActions.map((userAction) => (
            <UserActionRowCard key={userAction.userActionId} item={userAction} displayRemoteAddress={props.displayRemoteAddress} url={props.userActionsUrl} />
          ))}
        </tbody>
      </table>
    </div>

    {props.userActionsUrl && <div className="flex justify-end">
      <Button type="button" color="blue" icon labelPosition="right" onClick={navigateToUserActions}>
        {RESX.Planning.More}
        <Icon name="arrow right" />
      </Button>
    </div>}
  </>;
};

export default UserActionPanel;